import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ProductPage from './pages/ProductPage';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import EarlyAccessModal from './components/EarlyAccessModal';
import AnnouncementBanner from './components/AnnouncementBanner';
import EarlyAccessContext from './EarlyAccessContext';

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <EarlyAccessContext.Provider value={() => setModalOpen(true)}>
      <div className="container-full">
        <ScrollToTop />
        <AnnouncementBanner />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/about.html" element={<Navigate to="/about" replace />} />
          <Route path="/services.html" element={<Navigate to="/services" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <BackToTop />
        <EarlyAccessModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
      </div>
    </EarlyAccessContext.Provider>
  );
}

export default App;
